import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Stripe } from '@capacitor-community/stripe';
import { ModalController } from '@ionic/angular';
import { map, Observable, of } from 'rxjs';
import { PackageSubscriptionDetailsComponent } from 'src/app/components/shared/modals/package-subscription-details/package-subscription-details.component';
import { SelectPackageComponent } from 'src/app/components/shared/modals/select-package/select-package.component';
import { YesNoModalComponent } from 'src/app/components/shared/modals/yes-no-modal/yes-no-modal.component';
import { EPackageType } from 'src/app/micro-services/packages/enum/e-package-type';
import { Package } from 'src/app/micro-services/packages/models/package';
import { PackageFactoryService } from 'src/app/micro-services/packages/services/package-factory.service';
import { ESubscriptionType } from 'src/app/micro-services/subscription/enum/e-subscription-type';
import { Subscription } from 'src/app/micro-services/subscription/models/subscription';
import { SubscriptionPlateform } from 'src/app/micro-services/subscription/models/subscription-plateform';
import { SubscriptionFactoryService } from 'src/app/micro-services/subscription/services/subscription-factory.service';
import { SubscriptionFactory } from 'src/app/micro-services/subscription/subscription-factory';
import { User } from 'src/app/micro-services/user/models/user';
import { UserCoach } from 'src/app/micro-services/user/models/user-coach';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-subscribe',
  templateUrl: './subscribe.component.html',
  styleUrls: ['./subscribe.component.scss'],
})
export class SubscribeComponent implements OnInit {

  packages$: Observable<Package[]> ;
  save$: Observable<Package[]> ;
  userPackages$: Observable<Package[]> ;
  
  constructor(
    private userService : UserService,
    private packageFactoryService : PackageFactoryService,
    private router : Router,
    private modalController : ModalController,
    private subServiceFactory : SubscriptionFactoryService
  ) { }

  ngOnInit() {
    this.packages$ = this.save$ = this.packageFactoryService.create(EPackageType.Plateform).getPackages(EPackageType.Plateform);
    let user = this.userService.getUser() as UserCoach;
    this.userPackages$ = user.getPackage();
  }

  backClick(){
    this.router.navigateByUrl("/coach/account");
  }

  async openSelectedPackage(pack : Package){
    
    const modalPackage = await this.modalController.create({
      component : SelectPackageComponent,
      componentProps : { 
        pack : pack,
        recurrence : "m"
       }
    });

    modalPackage.present();

    let {data, role } = await modalPackage.onWillDismiss();
    
    if(role == "confirm"){
      this.userPackages$ = of([pack]);
    }

  }

  async revokePackage(pack : Package){
    const modalPackage = await this.modalController.create({
      component : YesNoModalComponent,
      componentProps : { 
        title : "Suppression ",
        text : "Vous allez annuler votre abonnement. Aucun Remboursement ne sera effectué."
       }
    });

    modalPackage.present();

    const { role } = await modalPackage.onWillDismiss();

    if (role === 'confirm') {
      
      this.subServiceFactory.create(ESubscriptionType.Plateform).revokeUserSubscriptionBypackage(pack).subscribe({
        next : async (result : any) => {
          this.userPackages$ = of([]);
        },
        error : (err) => {
          
        }
      })
      
    }
  }


    async packageSubscriptionDetails(pack : Package){
    
    const modalPackage = await this.modalController.create({
      component : PackageSubscriptionDetailsComponent,
      componentProps : { 
        package : pack
       }
    });

    modalPackage.present();

    let {data, role } = await modalPackage.onDidDismiss();

    if(role == "unsubscribe"){

      this.revokePackage(pack);
    }

  }

}
